module.exports = __webpack_public_path__ + "img/0_u.29310285.jpg";